/***
 * Created on 2023/10/3
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
// import ReactDOMClient from "react-dom/client";
// import singleSpaReact from "single-spa-react";
import sharedI18n from "common/SharedI18n";
import {I18nextProvider} from "react-i18next";

import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import SigninSwitchAccount from "../component/signin_switch_account";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});

const Wrapper = () => {
    return (
        <I18nextProvider i18n={sharedI18n} >
            <QueryClientProvider client={queryClient}>
                <SigninSwitchAccount />
            </QueryClientProvider>
        </I18nextProvider>
    )
}

export default Wrapper;
/*
const compLifeCycle = singleSpaReact({
    React,
    ReactDOM: null,
    ReactDOMClient,
    rootComponent: Wrapper,
    renderType: 'createRoot',
    errorBoundary: (err, info, page) => {
        return (
            <section>
                <div>Signin Switch Account Component renders with error occurs.</div>
                <div>{err}</div>
                <div>{info}</div>
                <div>{page}</div>
            </section>
        )
    }
})

export const { bootstrap, mount, unmount } = compLifeCycle;

 */